/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2023 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{keyToEnum as e,makeEnumTypePredicate as t}from"@keeex/js-utils/lib/types/enum.js";import{makeProfilePredicate as i}from"@keeex/js-utils/lib/types/record.js";import{SignatureFormat as o}from"./io.js";export const isSignatureSettings=e=>i({encoding:{optional:!0,predicate:t(o)},messageType:{optional:!0,predicate:e}});export var KeyType;!function(e){e.bitcoin="bitcoin",e.ethereum="ethereum",e.x509="x509"}(KeyType||(KeyType={}));export const keyTypeFromString=t=>e(t,KeyType);